import React, { useState, useEffect, useRef } from 'react';
import TextTransition, { presets } from 'react-text-transition';
import styles from "./menu.module.css";
import 'animate.css';
//icons
import { GrDocumentDownload ,FaHome, FaFolder, FaChevronDown, FaBook, FaUserFriends, FaChevronUp, FaSignOutAlt, FaCalendar, FaBrain, FaBriefcaseMedical, FaNotesMedical, FaChevronRight, FaFileInvoiceDollar, FaMapMarkedAlt } from "react-icons/fa";
import { FaGear } from "react-icons/fa6";
import { MdStorage } from 'react-icons/md';
import { BsFillFileEarmarkBarGraphFill } from "react-icons/bs";
import { useAuth } from '../context/AuthContext';
import { PiNewspaperClippingFill } from 'react-icons/pi';
import { RiFileInfoFill, RiTableView } from 'react-icons/ri';
import { GrMoney, GrNotes } from 'react-icons/gr';
import { GrCatalog } from "react-icons/gr";
import { LuTicket } from 'react-icons/lu';
import { FaMoneyBill } from "react-icons/fa";
import { HiDocumentReport  } from "react-icons/hi";
import { LuLogs } from "react-icons/lu";



//

export default function Menu(props) {
    const { handleLogout,setMenuActual, menuActual, isExandMenu, setEstados, setMunicipios, setCodigos, permisos } = useAuth();
    const [expand, setExpand] = useState(() => {
        const saved = localStorage.getItem('expandMenu');
        return saved === 'true' ? true : false;
    });
    const [isLoading, setIsLoading] = useState(false);
    const [expandMenu1, setExpandMenu1] = useState(false);
    const [expandMenu2, setExpandMenu2] = useState(false);
    const [expandMenu3, setExpandMenu3] = useState(false);
    const [expandMenu4, setExpandMenu4] = useState(false);
    const [expandMenu5, setExpandMenu5] = useState(false);
    const [expandMenu6, setExpandMenu6] = useState(false);
    const [expandMenu7, setExpandMenu7] = useState(false);
    const [expandMenu8, setExpandMenu8] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const handleMouseLeave = () => {
        if (!isLoading) {
            setIsLoading(true);
            setExpand(false);
            setTimeout(() => {
                setIsVisible(false);
            }, 700);
            setTimeout(() => {
                setIsLoading(false);
            }, 1300);
        }
    };
    const handleMouseEnter = () => {
        if (!isLoading) {
            setIsLoading(true);
            setIsVisible(true);
            setExpand(true);
            setTimeout(() => {
                setIsLoading(false);
            }, 700);
        }
    };
    const handleChangeMenu = (e) => {
        setMenuActual(e.currentTarget.id);
        handleMouseLeave();
    };
    useEffect(() => {
        localStorage.setItem('expandMenu', expand.toString());
    }, [expand]);
    
    return (
        <>
            <div className={styles.containerMini} onMouseEnter={handleMouseEnter} onMouseMove={handleMouseEnter} style={{ display: isExandMenu ? "none" : "" }}>
                <div className={styles.itemMini} style={{ padding: "15px 0px 0px 10px", color: "white", height: "28px" }}>
                    <img src='./assets/image/logo3.png'></img>
                </div>
                <hr style={{ color: "white" }}></hr>

                {
                    permisos.findIndex(item => item.identifier === "HOME") !== -1 ?
                        <>
                            <div className={menuActual.includes("home") ? styles.itemMiniActive : styles.itemMini}>
                                <FaHome />
                            </div>
                        </>
                        :
                        <></>
                }
                {
                    (permisos.findIndex(item => item.identifier === "CorteCaja") !== -1) ?
                        <>
                            <div className={menuActual.includes("corte") ? styles.itemMiniActive : styles.itemMini}>
                                <FaFileInvoiceDollar />
                            </div>
                        </>
                        :
                        <></>
                }
                {
                   (permisos.findIndex(item => item.identifier === "Pag") !== -1) ?
                        <>
                            <div className={menuActual.includes("pagos") ? styles.itemMiniActive : styles.itemMini}>
                                <FaMoneyBill />
                            </div>
                        </>
                        :
                        <></>
                }
                {
                    (permisos.findIndex(item => item.identifier === "Prest") !== -1 || permisos.findIndex(item => item.identifier === "Client") !== -1) ?
                        <>
                            <div className={menuActual.includes("prestamo") ? styles.itemMiniActive : styles.itemMini}>
                                <RiTableView />
                            </div>
                        </>
                        :
                        <></>
                }
                {
                    permisos.findIndex(item => item.identifier.includes("Vale")) !== -1 ?
                        <>
                            <div className={menuActual.includes("vales") ? styles.itemMiniActive : styles.itemMini}>
                                <LuTicket />


                            </div>
                        </>
                        :
                        <></>
                }
                {
                    permisos.findIndex(item => item.identifier.startsWith("Cat")) !== -1 ?
                        <>
                            <div className={menuActual.includes("catalog") ? styles.itemMiniActive : styles.itemMini}>
                                <GrCatalog />
                            </div>
                        </>
                        :
                        <></>
                }
                {
                    permisos.findIndex(item => item.identifier.startsWith("Config")) !== -1 ?
                        <>
                            <div className={menuActual.includes("config") ? styles.itemMiniActive : styles.itemMini}>
                                <FaGear />
                            </div>
                        </>
                        :
                        <></>
                }
                {
                    true ?
                        <>
                            <div className={menuActual.includes("document") ? styles.itemMiniActive : styles.itemMini}>
                                <FaBook />
                            </div>
                        </>
                        :
                        <></>
                }
                {
                    true ?
                        <>
                            <div className={menuActual.includes("rutas") ? styles.itemMiniActive : styles.itemMini}>
                                <FaMapMarkedAlt />
                            </div>
                        </>
                        :
                        <></>
                }
            </div>
            <div className={`${isExandMenu ? styles.mainContainer2 : styles.mainContainer}`} style={{ display: isExandMenu ? "" : isVisible ? "" : "none" }}>
                <div className={`${styles.container} ${isExandMenu ? "animate__animated animate__slideInLeft" : expand ? "animate__animated animate__slideInLeft" : "animate__animated animate__slideOutLeft"}`} onMouseLeave={handleMouseLeave}>
                    <div className={styles.logo} >
                        <img src='./assets/image/logo3.png'></img>&nbsp;&nbsp; <b style={{ marginRight: "10px" }}>INVIRTIENDO </b> PLUS
                    </div>
                    <hr style={{ color: "white" }}></hr>
                    {
                        permisos.findIndex(item => item.identifier === "HOME") !== -1 ?
                            <>
                                <div className={menuActual === "homeMenu" ? styles.itemActive : styles.item} id="homeMenu" onClick={handleChangeMenu} >
                                    <div className={styles.icon} >
                                        <FaHome />
                                    </div>
                                    <div className={styles.title}>
                                        Inicio
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                                </div>
                            </>
                            :
                            <></>
                    }
                    {
                        permisos.findIndex(item => item.identifier === "CorteCaja") !== -1 ?
                            <>
                                <div className={menuActual === "corte" ? styles.itemActive : styles.item} id="corte" onClick={handleChangeMenu} >
                                    <div className={styles.icon} >
                                        <FaFileInvoiceDollar />
                                    </div>
                                    <div className={styles.title}>
                                        Corte de Caja
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                                </div>
                            </>
                            :
                            <></>
                    }
                    {
                        (permisos.findIndex(item => item.identifier === "Pag") !== -1) ?
                            <>
                                <div className={menuActual === "pagos" ? styles.itemActive : styles.item} id="pagos" onClick={handleChangeMenu} >
                                    <div className={styles.icon} >
                                        <FaMoneyBill />
                                    </div>
                                    <div className={styles.title}>
                                        Pagos
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                                </div>
                            </>
                            :
                            <></>
                    }
                    {
                        (permisos.findIndex(item => item.identifier === "Prest") !== -1 || permisos.findIndex(item => item.identifier === "Client") !== -1) ?
                            <>
                                <div className={menuActual.includes("prestamo") ? styles.itemActive : styles.item}>
                                    <div className={styles.icon} onClick={() => { setMenuActual("prestamoMenu"); handleMouseLeave(); }}>
                                        <RiTableView />
                                    </div>
                                    <div className={styles.title} onClick={() => { setMenuActual("prestamoMenu"); handleMouseLeave(); }}>
                                        Préstamos
                                    </div>
                                    <div className={styles.sub} onClick={() => setExpandMenu1(!expandMenu1)}>
                                        {
                                            (
                                                expandMenu1 ?
                                                    (<FaChevronUp />)
                                                    :
                                                    (<FaChevronRight />)
                                            )
                                        }

                                    </div>

                                </div>
                            </>
                            :
                            <></>
                    }
                    <div className={`${styles.expandMenu} ${"animate__animated animate__flipInX"}`} style={{ display: expandMenu1 ? "" : "none" }}>

                        {
                            (permisos.findIndex(item => item.identifier === "Client") !== -1) ?
                                <>
                                    <div className={menuActual === "prestamo1" ? styles.expandItemActive : styles.expandItem} id="prestamo1" onClick={handleChangeMenu}>
                                        - Clientes
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "MetAse") !== -1) ?
                                <>
                                    <div className={menuActual === "prestamo4" ? styles.expandItemActive : styles.expandItem} id="prestamo4" onClick={handleChangeMenu}>
                                        - Metas
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "Prest") !== -1) ?
                                <>
                                    <div className={menuActual === "prestamo3" ? styles.expandItemActive : styles.expandItem} id="prestamo3" onClick={handleChangeMenu}>
                                        - Prestamos
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "Nomina") !== -1) ?
                                <>
                                    <div className={menuActual === "prestamo5" ? styles.expandItemActive : styles.expandItem} id="prestamo5" onClick={handleChangeMenu}>
                                        - Nomina Asesores
                                    </div>
                                </>
                                :
                                <></>
                        }


                    </div>


                    {
                        permisos.findIndex(item => item.identifier.includes("Vale")) !== -1 ?
                            <>
                                <div className={menuActual === "vales" ? styles.itemActive : styles.item} id="vales" onClick={handleChangeMenu} >
                                    <div className={styles.icon} >
                                        <LuTicket />
                                    </div>
                                    <div className={styles.title}>
                                        Vales
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                                </div>
                            </>
                            :
                            <></>
                    }
                    {
                        permisos.findIndex(item => item.identifier.startsWith("Cat")) !== -1 ?
                            <>
                                <div className={menuActual.includes("catalog") ? styles.itemActive : styles.item}>
                                    <div className={styles.icon} onClick={() => { setMenuActual("catalogMenu"); handleMouseLeave(); }}>
                                        <MdStorage />
                                    </div>
                                    <div className={styles.title} onClick={() => { setMenuActual("catalogMenu"); handleMouseLeave(); }}>
                                        Catálogos
                                    </div>
                                    <div className={styles.sub} onClick={() => setExpandMenu2(!expandMenu2)}>
                                        {
                                            (
                                                expandMenu2 ?
                                                    (<FaChevronUp />)
                                                    :
                                                    (<FaChevronRight />)
                                            )
                                        }

                                    </div>

                                </div>
                            </>
                            :
                            <></>
                    }
                    <div className={`${styles.expandMenu} ${"animate__animated animate__flipInX"}`} style={{ display: expandMenu2 ? "" : "none" }}>
                        {
                            (permisos.findIndex(item => item.identifier === "CatAse") !== -1) ?
                                <>
                                    <div className={menuActual === "catalog1" ? styles.expandItemActive : styles.expandItem} id="catalog1" onClick={handleChangeMenu}>
                                        - Asesores
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "CatAval") !== -1) ?
                                <>

                                    <div className={menuActual === "catalog2" ? styles.expandItemActive : styles.expandItem} id="catalog2" onClick={handleChangeMenu}>
                                        - Avales
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "CatCoor") !== -1) ?
                                <>

                                    <div className={menuActual === "catalog3" ? styles.expandItemActive : styles.expandItem} id="catalog3" onClick={handleChangeMenu}>
                                        - Coordinadores
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "CatDist") !== -1) ?
                                <>

                                    <div className={menuActual === "catalog4" ? styles.expandItemActive : styles.expandItem} id="catalog4" onClick={handleChangeMenu}>
                                        - Distribuidores
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "CatEmp") !== -1) ?
                                <>

                                    <div className={menuActual === "catalog5" ? styles.expandItemActive : styles.expandItem} id="catalog5" onClick={handleChangeMenu}>
                                        - Empresas
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "CatEmpAfi") !== -1) ?
                                <>

                                    <div className={menuActual === "catalog6" ? styles.expandItemActive : styles.expandItem} id="catalog6" onClick={handleChangeMenu}>
                                        - Empresas Afiliadas
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "CatSuc") !== -1) ?
                                <>

                                    <div className={menuActual === "catalog7" ? styles.expandItemActive : styles.expandItem} id="catalog7" onClick={handleChangeMenu}>
                                        - Sucursales
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "CatHoli") !== -1) ?
                                <>

                                    <div className={menuActual === "catalog8" ? styles.expandItemActive : styles.expandItem} id="catalog8" onClick={handleChangeMenu}>
                                        - Dias Festivos
                                    </div>
                                </>
                                :
                                <></>
                        }

                    </div>
                    {
                        permisos.findIndex(item => item.identifier.startsWith("Config")) !== -1 ?
                            <>
                                <div className={menuActual.includes("config") ? styles.itemActive : styles.item}>
                                    <div className={styles.icon} onClick={() => { setMenuActual("configMenu"); handleMouseLeave(); }}>
                                        <FaGear />
                                    </div>
                                    <div className={styles.title} onClick={() => { setMenuActual("configMenu"); handleMouseLeave(); }}>
                                        Configuración
                                    </div>
                                    <div className={styles.sub} onClick={() => setExpandMenu3(!expandMenu3)}>
                                        {
                                            (
                                                expandMenu3 ?
                                                    (<FaChevronUp />)
                                                    :
                                                    (<FaChevronRight />)
                                            )
                                        }

                                    </div>

                                </div>
                            </>
                            :
                            <></>
                    }
                    <div className={`${styles.expandMenu} ${"animate__animated animate__flipInX"}`} style={{ display: expandMenu3 ? "" : "none" }}>

                        {
                            (permisos.findIndex(item => item.identifier === "ConfigUsers") !== -1) ?
                                <>

                                    <div className={menuActual === "config1" ? styles.expandItemActive : styles.expandItem} id="config1" onClick={handleChangeMenu}>
                                        - Usuarios
                                    </div>
                                </>
                                :
                                <></>
                        }
                        {
                            (permisos.findIndex(item => item.identifier === "ConfigPermissions") !== -1) ?
                                <>

                                    <div className={menuActual === "config2" ? styles.expandItemActive : styles.expandItem} id="config2" onClick={handleChangeMenu}>
                                        - Permisos
                                    </div>
                                </>
                                :
                                <></>
                        }

                    </div>
                    {
                       permisos.findIndex(item => item.identifier.startsWith("Reports")) !== -1 ?
                        <>
                            <div className={menuActual.includes("reportes") ?  styles.itemActive : styles.item} id="reportes" onClick={handleChangeMenu} >
                                 <div className={styles.icon} >
                                        <HiDocumentReport    />
                                    </div>
                                    <div className={styles.title}>
                                        Reportes
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                            </div>
                        </>
                        :
                        <></>
                    }
                     {
                       permisos.findIndex(item => item.identifier.startsWith("AuditLog")) !== -1 ?
                        <>
                            <div className={menuActual.includes("auditlog") ?  styles.itemActive : styles.item} id="auditlog" onClick={handleChangeMenu} >
                                 <div className={styles.icon} >
                                        <LuLogs    />
                                    </div>
                                    <div className={styles.title}>
                                        Log de Auditoria
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                            </div>
                        </>
                        :
                        <></>
                    }
                    {
                        false ?
                            <>
                                <div className={menuActual === "rutas" ? styles.itemActive : styles.item} id="rutas" onClick={handleChangeMenu} >
                                    <div className={styles.icon} >
                                        <FaMapMarkedAlt />
                                    </div>
                                    <div className={styles.title}>
                                        Rutas
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                                </div>
                            </>
                            :
                            <></>
                    }
                    {
                        true ?
                            <>
                                <div className={menuActual === "document" ? styles.itemActive : styles.item} id="document" onClick={handleChangeMenu} >
                                    <div className={styles.icon} >
                                        <FaBook />
                                    </div>
                                    <div className={styles.title}>
                                        Documentación
                                    </div>
                                    <div className={styles.sub}>
                                    </div>
                                </div>
                            </>
                            :
                            <></>
                    }

                    <hr></hr>
                    <div className={styles.item} onClick={() => handleLogout(setEstados, setMunicipios, setCodigos, setMenuActual)} >
                        <div className={styles.icon} >
                            <FaSignOutAlt />
                        </div>
                        <div className={styles.title}>
                            Cerrar Sesión
                        </div>
                        <div className={styles.sub}>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

